import { apiClient, v1 } from '@/api/client';
import { fetchFileAsBlobUrl } from '@/util/files';
import {
  ConversationDto,
  ConversationMessageDto,
  FindHistoryRequest,
  GetConversationByIdRequest,
  Rating,
  StartConversationRequest,
} from './api.types';

export const startConversation = (request: StartConversationRequest) =>
  fetch(
    new Request(`/api/v1/conversationstreaming`, {
      method: 'post',
      headers: apiClient.getHeaders(),
      body: JSON.stringify({ ...request }),
    })
  );

export const continueConversation = (conversationId: string, query: string) =>
  fetch(
    new Request(`/api/v1/conversationstreaming/${conversationId}`, {
      method: 'post',
      headers: apiClient.getHeaders(),
      body: JSON.stringify({ query }),
    })
  );

export const findConversations = (queryParams: FindHistoryRequest) =>
  v1.get<ConversationDto[]>('conversation', { queryParams });

export const fetchConversation = (
  conversationId: string,
  queryParams: GetConversationByIdRequest
) => v1.get<ConversationDto>(`conversation/${conversationId}`, { queryParams });

export const deleteConversation = (conversationId: string) =>
  v1.remove(`conversation/${conversationId}`);

export interface FetchBlobUrlOptions {
  topicId: string;
  documentId: string;
  pageNumber: number;
  dpi: number;
}

export const fetchReferenceImageBlobUrl = ({
  topicId,
  documentId,
  pageNumber,
  dpi,
}: FetchBlobUrlOptions): Promise<string | undefined> => {
  const url = `topic/${topicId}/document/${documentId}/page/${pageNumber}.png?dpi=${dpi}`;
  const mimeType = 'image/png';
  return fetchFileAsBlobUrl(url, mimeType);
};

export const rateConversationMessage = (
  conversationId: string,
  messageId: string,
  rating?: Rating
) =>
  v1.put<ConversationMessageDto>(
    `conversation/${conversationId}/message/${messageId}/rating`,
    { rating }
  );
